import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { CommunicationService } from '../../airport/service/communication.service';
import { SuggestAChangeService } from '../../airport/service/suggest-a-change.service';
import { SuggestAChange } from '../models/suggest-a-change.model';
import { State } from '../state-view/state.model';
import { UserService } from '../user/user.service';
import { UserInfo } from '../models/user-info.model';

@Component({
  selector: 'app-suggest-a-change',
  templateUrl: './suggest-a-change.component.html',
  styleUrls: ['./suggest-a-change.component.scss']
})
export class SuggestAChangeComponent implements OnInit {
  isLoading = true;
  formGroup: FormGroup;
  isAirport = false;
  ident: number;
  airportAbbrev: string;
  businessId: number;
  state = State.Empty;
  private _userInfo: UserInfo;

  constructor(private _matDialogRef: MatDialogRef<SuggestAChangeComponent>,
              @Inject(MAT_DIALOG_DATA) data,
              private _suggestAChangeService: SuggestAChangeService,
              private _userService: UserService) {
      this.isAirport = data.airportID != null;
      this.ident = data.airportID || data.businessID;
      this.airportAbbrev = data.airportAbbrev;
  }

  ngOnInit() {
    this._matDialogRef.backdropClick().subscribe(() => {
      this.close({cancelBtnClicked: true});
    });
    this.formGroup = new FormGroup({
      name: new FormControl('', [Validators.maxLength(50)]),
      email: new FormControl('', [Validators.email]),
      details: new FormControl('', [Validators.required]),
    });

    this.isLoading = false;

    // Update state based on latest available userInfo, and subscribe to any future
    // changes to userInfo.
    this._userInfo = this._userService.userInfo.getValue();
    this._userService.userInfo.subscribe(u => {
      // Update userInfo
      this._userInfo = u;
      // Set state to loaded
      this.state = State.Content;
    });
  }

  async submit() {
    try {
      let result: any;
      const changeRequest: SuggestAChange = {
        name: this.formGroup.value.name,
        email: this.formGroup.value.email,
        details: this.formGroup.value.details,
        recId: this._userInfo ? +this._userInfo.masterCustomerId : null
      };

      if (this.isAirport) {
        result = await this._suggestAChangeService.postChangeRequestAirport(this.ident, this.airportAbbrev, changeRequest);
      } else {
        result = await this._suggestAChangeService.postChangeRequestBusiness(this.ident, changeRequest);
      }
      this.close({cancelBtnClicked: false, success: true});
    } catch (e) {
      this.close({cancelBtnClicked: false, success: false, error: e.error});
    }
  }

  /**
   * triggered by cancel button click event
   */
  cancel () {
    this.close({cancelBtnClicked: true});
  }

  /**
   * closes modal
   * @param data
   */
  close(data: any) {
    this._matDialogRef.close(data);
  }
}
